<template>
  <div>
    <div class="card shadow">
      <a id="button"></a>
      <div class="card-header bg-transparent">
        <div>
          <h3 class="mb-0">
            {{ $t('message.edit') }} {{ $t('message.kinesitherapyConsultations') }}
          </h3>
        </div>
      </div>

      <div class="card-body">

        <h3 class="text-center"> {{$t('message.infoConsultation')}}
        </h3>
        <b-form   v-if="show">
          <b-container>
            <b-row>
              <b-col sm="12">
                <span class="obligatoire">*</span>
                <b-form-group id="timeLine-group" :label="$tc('message.TimelineSelect', 2)" label-for="timeLine" >
                    <select id="timeLine" v-model="$v.form.ligne_de_temps_id.$model" class="form-control is-invalid retirerBordure" @change="clearErrorField('ligne_de_temps_id')" required>
                        <option data-placeholder="true"></option>
                        <option v-for="item in lignetempsRows" :key="item.id" :value="item.id">
                            {{item.motif}} <b-badge variant="info">{{item.date}}</b-badge>
                        </option>
                    </select>
                    <b-form-invalid-feedback v-if="$v.form.ligne_de_temps_id.$error">
                        {{ $t('message.requiredField') }}
                    </b-form-invalid-feedback>
                    <span v-if="errorshasField('ligne_de_temps_id')" style="color:red">
                        {{getErrorsField('ligne_de_temps_id')}}
                    </span>
                </b-form-group>
              </b-col>
              <b-col sm="12">
                <span  class="obligatoire">*</span>
                <b-form-group
                      id="institution-group"
                      :label="$t('message.institutionConsultation')"
                      label-for="institution"
                  >
                    <slim-element return-value="id" selected-id="institution" :afficher="true" :element.sync="$v.form.etablissement_id.$model+''" :data.sync="mInstitutions"></slim-element>
                    <div class="invalid-feedback" v-if="$v.form.etablissement_id.$error">
                      {{ $t('message.requiredField') }}
                    </div>
                    <span v-if="errorshasField('etablissement_id')" class="custom-invalid">
                                                    {{getErrorsField('etablissement_id')}}
                                                    </span>
                  </b-form-group>
              </b-col>
              <b-col sm="12">
                <span  class="obligatoire">*</span>

                <b-form-group
                    id="consultation-group"
                    :label="$t('message.consultationDate')"
                    label-for="consultation"
                    description="">
        
                  <b-form-input
                      id="consultation"
                      v-model="$v.form.date_consultation.$model"
                      :state="$v.form.date_consultation.$dirty ? !(errorshasField('date_consultation') || $v.form.date_consultation.$error) : null"
                      type="date"
                      required
                      @focus="clearErrorField('date_consultation')"
                  ></b-form-input>

                  <b-form-invalid-feedback v-if="!$v.form.date_consultation.required">
                    {{ $t('message.requiredField') }}
                  </b-form-invalid-feedback>

                  <b-form-invalid-feedback v-else-if="errorshasField('date_consultation')">
                    {{ getErrorsField('date_consultation') }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <b-col sm="12">
                <b-form-group
                    id="contributors-group"
                    :label="$tc('message.contributors',2)"
                    label-for="contributors"
                >
                <slim-group-element return-value="id"
                    selected-id="contributors"  
                    :afficher="true"
                    :element.sync="$v.form.contributors.$model"
                    :data.sync="mContributors"
                    show-value="nom"
                  >
                  </slim-group-element>
                  
                 <!-- <select id="contributors" v-model="$v.form.contributors.$model"
                          @change="clearErrorField('contributeurs')"
                          class="form-control is-invalid retirerBordure"
                          required
                          multiple
                  >
                    <option data-placeholder="true"></option>
                    <option v-for="item in mContributors" :key="item.id" :value="item.id">
                      {{ item.nom }}
                    </option>
                  </select> -->

                  <span v-if="errorshasField('contributeurs')" style="color:red">
                                    {{getErrorsField('contributeurs')}}
                                    </span>
                </b-form-group>
              </b-col>

            </b-row>

            <b-row>
              <b-col sm="12">
                <b-form-group
                    id="anamnese-group"
                    :label="$t('message.anamnesis')"
                    label-for="anamnese"
                >
                  <editor
                      :api-key="tinyKey"
                      initialValue=""
                      v-model="$v.form.anamnese.$model"
                      :state="$v.form.anamnese.$dirty ? !(errorshasField('anamnese') || $v.form.anamnese.$error) : null"
                      @focus="clearErrorField('anamnese')"
                      :init="{
                                              height: 200,
                                              menubar: false,
                                              plugins: plugins,
                                              toolbar:toolbar
                                            }"
                  >
                  </editor>

                  <b-form-invalid-feedback v-if="errorshasField('anamnese')">
                    {{ getErrorsField('anamnese') }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>

            </b-row>
            <b-row>
              <b-col sm="12">
                <b-form-group
                    id="occupation-group"
                    :label="$t('message.profession')"
                    label-for="occupation-propose"
                >
                  <b-form-input
                      id="occupation"
                      v-model="$v.form.profession.$model"
                      :state="$v.form.profession.$dirty ? !(errorshasField('profession') || $v.form.profession.$error) : null"
                      @focus="clearErrorField('profession')"
                  ></b-form-input>

                  <b-form-invalid-feedback v-if="errorshasField('profession')">
                    {{ getErrorsField('profession') }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="12">
                <b-form-group
                    id="evaluation-global-group"
                    :label="$t('message.evaluationGlobale')"
                    label-for="evaluation-global"
                >
                  <editor
                      :api-key="tinyKey"
                      initialValue=""
                      v-model="$v.form.evaluation_globale.$model"
                      :state="$v.form.evaluation_globale.$dirty ? !(errorshasField('evaluation-globale') || $v.form.evaluation_globale.$error) : null"
                      @focus="clearErrorField('evaluation-globale')"
                      :init="{
                                              height: 200,
                                              menubar: false,
                                              plugins: plugins,
                                              toolbar:toolbar
                                            }"
                  >
                  </editor>

                  <b-form-invalid-feedback v-if="errorshasField('evaluation-globale')">
                    {{ getErrorsField('evaluation-globale') }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="12">
                <b-form-group
                    id="impression-diagnostique-group"
                    :label="$t('message.impressionDiagnostique')"
                    label-for="impression-diagnostique"
                >
                  <editor
                      :api-key="tinyKey"
                      initialValue=""
                      v-model="$v.form.impression_diagnostique.$model"
                      :state="$v.form.impression_diagnostique.$dirty ? !(errorshasField('impression-diagnostique') || $v.form.impression_diagnostique.$error) : null"
                      @focus="clearErrorField('impression-diagnostique')"
                      :init="{
                                              height: 200,
                                              menubar: false,
                                              plugins: plugins,
                                              toolbar:toolbar
                                            }"
                  >
                  </editor>

                  <b-form-invalid-feedback v-if="errorshasField('impression-diagnostique')">
                    {{ getErrorsField('impression-diagnostique') }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="12">
                <b-form-group
                    id="examens-complementaires-group"
                    :label="$t('message.examensComplementaires')"
                    label-for="examens-complementaires"
                >
                  <editor
                      :api-key="tinyKey"
                      initialValue=""
                      v-model="$v.form.examens_complementaires.$model"
                      :state="$v.form.examens_complementaires.$dirty ? !(errorshasField('examens-complementaires') || $v.form.examens_complementaires.$error) : null"
                      @focus="clearErrorField('examens-complementaires')"
                      :init="{
                                              height: 200,
                                              menubar: false,
                                              plugins: plugins,
                                              toolbar:toolbar
                                            }"
                  >
                  </editor>

                  <b-form-invalid-feedback v-if="errorshasField('examens-complementaires')">
                    {{ getErrorsField('examens-complementaires') }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="12">
                <b-form-group
                    id="conduite-group"
                    :label="$t('message.conduite')"
                    label-for="conduite"
                >
                  <editor
                      :api-key="tinyKey"
                      initialValue=""
                      v-model="$v.form.conduite.$model"
                      :state="$v.form.conduite.$dirty ? !(errorshasField('conduite') || $v.form.conduite.$error) : null"
                      @focus="clearErrorField('conduite')"
                      :init="{
                                              height: 200,
                                              menubar: false,
                                              plugins: plugins,
                                              toolbar:toolbar
                                            }"
                  >
                  </editor>

                  <b-form-invalid-feedback v-if="errorshasField('conduite')">
                    {{ getErrorsField('conduite') }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col sm="12">
                <b-form-group
                    id="conclusions-group"
                    :label="$t('message.conclusion')"
                    label-for="conclusions"
                >
                  <editor
                      :api-key="tinyKey"
                      id="conclusions"
                      v-model="$v.form.conclusion.$model"
                      :state="$v.form.conclusion.$dirty ? !(errorshasField('conclusion') || $v.form.conclusion.$error) : null"
                      @focus="clearErrorField('conclusions')"
                      :init="{
                                              height: 200,
                                              menubar: false,
                                              plugins: plugins,
                                              toolbar:toolbar
                                            }"
                  >
                  </editor>
                  <b-form-invalid-feedback v-if="errorshasField('conclusion')">
                    {{ getErrorsField('conclusion') }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>

            </b-row>

            <b-row>
             <!-- <b-col sm="12">

                <b-form-group
                    id="rendez-group"
                    :label="$t('message.appointmentDate')"
                    label-for="consultation"
                    description="">
                  <b-form-input
                      id="consultation"
                      v-model="$v.form.rendez_vous.$model"
                      :state="$v.form.rendez_vous.$dirty ? !(errorshasField('rendez_vous') || $v.form.rendez_vous.$error) : null"
                      type="date"
                      required
                      @focus="clearErrorField('rendez_vous')"
                  ></b-form-input>

                  <b-form-invalid-feedback v-if="!$v.form.rendez_vous.required">
                    {{ $t('message.requiredField') }}
                  </b-form-invalid-feedback>

                  <b-form-invalid-feedback v-else-if="errorshasField('rendez_vous')">
                    {{ getErrorsField('rendez_vous') }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col> -->
              <b-col sm="12">

                <b-form-group
                    id="rendezv-group"
                    :label="$t('message.appointmentDate')"
                    label-for="consultation"
                    description="">
                  <vue-ctk-date-time-picker class="border-dark" v-model="dateRdv"></vue-ctk-date-time-picker>

                </b-form-group>
              </b-col>
              <b-col sm="12" >
                <b-form-group
                    id="traitement-appointmentReason-group"
                    :label="$t('message.appointmentReason')"
                    label-for="appointmentReason"
                >
                  <editor
                      :api-key="tinyKey"
                      id="appointmentReason"
                      v-model="$v.form.rdv.motifs.$model"
                      :init="{
                                              height: 200,
                                              menubar: false,
                                              plugins: plugins,
                                              toolbar:toolbar
                                            }"
                  >
                  </editor>
                </b-form-group>
              </b-col>


              <b-col md="12" sm="12">
                <b-form-group
                    id="isConsultantDoctor-group"
                    :label="$t('message.isConsultantDoctor')"
                    label-for="isConsultantDoctor">
                  <b-form-radio
                      v-model="$v.rdv.isConsultantDoctor.$model"
                      @click="$v.rdv.isConsultantDoctor.$model = 'true'"
                      name="isConsultantDoctor"
                      value="true"
                      :inline="true"
                  >
                    {{ $t('message.yes') }}
                  </b-form-radio>
                  <b-form-radio
                      v-model="$v.rdv.isConsultantDoctor.$model"
                      name="isConsultantDoctor"
                      @click="$v.rdv.isConsultantDoctor.$model = 'false'"
                      value="false"
                      :inline="true"
                  >
                    {{ $t('message.no') }}
                  </b-form-radio>
                  <b-form-invalid-feedback v-if="errorshasField('isConsultantDoctor')">
                    {{ getErrorsField('isConsultantDoctor') }}
                  </b-form-invalid-feedback>

                  <b-form-invalid-feedback v-if="$v.rdv.isConsultantDoctor.$error">
                    {{ $t('message.requiredField') }}
                  </b-form-invalid-feedback>

                </b-form-group>

              </b-col>

              <b-row v-if="rdv.isConsultantDoctor == 'false'" class="mt-3">
                <b-col md="12" sm="12">
                  <b-form-group
                      id="consultantDoctor-group"
                      :label="$t('message.select')+' '+$tc('message.medecin',1)"
                      label-for="patient">

                    <b-form-radio
                        v-model="$v.rdv.medecinSource.$model"
                        name="medecinSource"
                        value="fromMedicasure"
                        @click="$v.rdv.medecinSource.$model='fromMedicasure'"
                        :inline="true"
                    >
                      {{ $t('message.fromMedicasure') }}
                    </b-form-radio>
                    <b-form-radio
                        v-model="$v.rdv.medecinSource.$model"
                        name="medecinSource"
                        value="fromOthers"
                        @click="$v.rdv.medecinSource.$model='fromOthers'"
                        :inline="true"
                    >
                      {{ $t('message.fromOthers') }}
                    </b-form-radio>
                    <!-- Options -->
                    <select
                        v-if="rdv.medecinSource == 'fromMedicasure'"
                        id="consultantDoctor"
                        v-model="$v.rdv.praticien_id.$model"
                        class="form-control is-invalid border-light mt-2"
                    >
                      <option v-for="item in mContributors" :value="item.id" :key="item.id">
                        {{ item.nom }}
                      </option>
                    </select>

                    <b-form-input
                        id="doctorName"
                        class="mt-2"
                        v-else
                        v-model="$v.rdv.doctorName.$model"
                        :placeholder="$t('message.preciseDoctorName')"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-row>
              <b-row>
              <b-col sm="8">
                <b-form-group
                    id="upload-group"
                    :label="$t('message.uploadFile')"
                    label-for="upload"
                >
                  <b-form-file multiple
                               type="file"
                               accept=".jpeg, .png, .gif, .pdf, .docx"
                               ref="file_input"
                               id="upload"
                               :state="$v.form.documents.$dirty ? !$v.form.documents.$error : null"
                               :placeholder="$t('message.uploadFile')"
                  >
                    <template slot="file-name" slot-scope="{ names }">
                      <b-badge variant="dark">{{ names[0] }}</b-badge>
                      <b-badge v-if="names.length > 1" variant="dark" class="ml-1">
                        + {{ names.length - 1 }} More documents
                      </b-badge>
                    </template>
                  </b-form-file>
                  <span style="color: red" v-if="errorshasField('documents')">
                                        {{ getErrorsField('documents') }}
                                    </span>

                  <span style="color: red" v-if="maxFileSize.length>0" >{{ maxFileSize }}</span>

                </b-form-group>
              </b-col>
              <b-col sm="4">
                <b-form-group
                    id="u"
                    label="."
                    label-for="upload"
                >
                  <b-button @click="cleardocuments">{{ $t('message.emptyUpload') }}</b-button>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col sm="12">
                <h4 v-if="isDefine">Fichier joint </h4>
                <div v-if="uploadFiles.length>0">
                  <div  v-for="file in uploadFiles" :key="file.id">
                    <b-row>
                      <b-col sm="6">
                        <p class="mb-3"> {{file.nom}}  </p>
                      </b-col>
                      <b-col sm="6">
                        <button type="button" class="btn btn-success btn-sm" @click="openFile(file)">Afficher</button>
                        <button  type="button" class=" btn btn-danger btn-sm" @click="deletedFile(file)">Supprimer</button>
                      </b-col>
                    </b-row>
                  </div>
                </div>
              </b-col>
            </b-row>
            <b-row class="justify-content-sm-center">
              <b-button @click="onSubmit" variant="primary" v-if="can">
                {{ $t('message.edit') }}
              </b-button>
            </b-row>
          </b-container>
        </b-form>

      </div>
    </div>
  </div>
</template>

<script>
import Editor from "@tinymce/tinymce-vue";
import {mapGetters} from "vuex";
import _ from "lodash";
import moment from "moment";
import AppConfig from "../../../constants/AppConfig";
import $ from "jquery";
import {required} from "vuelidate/lib/validators";
import SlimSelect from "slim-select";
import SlimElement from "../../Layout/SlimElement";
import SlimGroupElement from '../../../components/CustomElement/slimGroupElement.vue';

export default {
  name: "EditKinesitherapie",

  components: {
    editor: Editor,
    SlimElement,
    SlimGroupElement,
  },

  computed: {
    ...mapGetters([
      "KinesitherapieConsultation",
      "practitioners",
      "controlDoctors",
      "reasons",
      "institutions",
      "userInstitutions",
      "errors",
      'hasAdminRole',
      'hasMedecinControleRole', 'hasAssistante',
      'hasPraticienRole','Timelines',]),

    form: function() {
      let consultation =  this.KinesitherapieConsultation;
      let self = this;
      let mContributeurs = [];

      if (_.isNull(consultation.rdv)){
        consultation.rdv = [];
        consultation.rdv['date']='';
        consultation.rdv['motif']='';
       consultation.rdv['isConsultantDoctor'] = 'true';
        consultation.rdv['medecinSource'] = 'fromMedicasure';
        consultation.rdv['doctorName'] =  '';
        consultation.rdv['praticien_id'] = JSON.parse(localStorage.getItem('user'))['id'];
        
      }else if(!_.isUndefined(consultation.rdv)){
        self.dateRdv = moment(consultation.rdv.date).format('YYYY-MM-DD HH:mm');
          if (_.isNull(consultation.rdv.nom_medecin)) {
          let practicien = null;
          if (this.hasPraticienRole || this.hasMedecinControleRole || this.hasAssistante){
            practicien = JSON.parse(localStorage.getItem('user'))['id'];
          }

          if (practicien == consultation.rdv.praticien_id) {
            self.rdv['isConsultantDoctor'] = 'true';
            self.rdv['praticien_id'] = practicien;
            self.rdv['medecinSource'] = 'fromMedicasure';
          } else {
            self.rdv['isConsultantDoctor'] = 'false';
            self.rdv['medecinSource'] = 'fromMedicasure';
            self.rdv['praticien_id'] = consultation.rdv.praticien_id;
          }

        } else {
          self.rdv['isConsultantDoctor'] = 'false';
          self.rdv['medecinSource'] = 'fromOthers';
          self.rdv['doctorName'] =  consultation.rdv.nom_medecin;
        }
      }

      // Définitions des contribiteurs
      _.forEach(consultation.operationables,function(contrubuteurs){
        mContributeurs.push(contrubuteurs.contributable_id);
      })
      consultation.contributors = mContributeurs;
      return consultation;
    },

    isDefine:function(){
      return this.uploadFiles.length>0;
    },

    uploadFiles:function(){
      return _.isUndefined(this.KinesitherapieConsultation.files) ? [] :this.KinesitherapieConsultation.files;
    },


    mInstitutions: function () {
      let iArray = [];

      _.forEach(_.orderBy(this.userInstitutions, ['created_at'], ['desc']), function (institution) {
        let i = {};

        i.text = ""+institution.name;
        i.id = ""+institution.id;
        iArray.push(i);
      });

      return iArray;
    },

    mReasons: function () {
      let rArray = [];

      if (!_.isUndefined(this.reasons)) {
        _.forEach(this.reasons, function (reason) {
          rArray.push({text: reason.description, value: reason.id})
        })
        return rArray;
      }
      return rArray;
    },

    descriptions: function () {
      let aArray = [];

      if (!_.isUndefined(this.allergies)) {
        _.forEach(this.allergies, function (allergy) {
          aArray.push({text: allergy.description, value: allergy.id})
        })
        return aArray;
      }
      return aArray;
    },

    can: function () {
      if (this.hasAdminRole) {
        return true;
      } else {
        return this.hasMedecinControleRole || this.hasPraticienRole || this.hasAssistante;
      }
    },
    lignetempsRows: function () {
      let self = this;
      let mArray = [];
      _.forEach(_.orderBy(self.Timelines, ['created_at'], ['desc']), function (timelines) {
          let motifs = "";
          let ids = "";

          if (timelines.hasOwnProperty('motif')) {

              motifs = timelines.motif.description;
              // ligne_de_temps_id = timelines.id;
              // console.log('ligne_de_temps_id', ligne_de_temps_id);

              if (motifs.length > 105) {
                  motifs = timelines.motif.description.substring(0, 105) + " ...";
              }
          }
          mArray.push({
              id: timelines.id,
              date: timelines.date_consultation,
              motif: motifs,
              etat: timelines.etat == null ? true : false,
          });
      });
      let sArray = mArray;
      mArray = self.filterResult(sArray, mArray);
      return mArray;
    },

    today: function () {
      return moment((new Date())).format('YYYY-MM-DD');
    },

    mPractitioners: function() {
      let pArray = [];

      _.forEach(_.orderBy(this.practitioners,['created_at'],['desc']), function(practitioner) {
        let p = {};
        if((typeof practitioner.user == 'object') && (!_.isNull(practitioner.user)) ){
          let prenom = practitioner.user.prenom != 'null' && !_.isNull(practitioner.user.prenom) ? practitioner.user.prenom : '';
          prenom =  prenom.toLowerCase();
          p.nom =  (practitioner.user.nom).toUpperCase() + " "+ prenom.charAt(0).toUpperCase() + prenom.substring(1);
          p.id = ""+practitioner.user.id;
          if (p.nom.length >0){
            pArray.push(p);
          }
        }

      });

      return pArray;
    },

    mDoctors: function() {
      let dArray = [];

      _.forEach(_.orderBy(this.controlDoctors,['created_at'],['desc']), function(doctor) {
        let d = {};
        if((typeof doctor.user == 'object') && (!_.isNull(doctor.user))){
          let prenom = doctor.user.prenom != null ?  doctor.user.prenom : "";
          prenom =  prenom.toLowerCase();
          d.nom =  (doctor.user.nom).toUpperCase() + " "+ prenom.charAt(0).toUpperCase() + prenom.substring(1);
          d.id = ""+doctor.user.id;

          if (d.nom.length >0){
            dArray.push(d);
          }
        }

      });

      return dArray;
    },

    mContributors:function () {
      let cArray = [];
      return cArray.concat(this.mDoctors,this.mPractitioners);
    }
  },

  data(){
    return {
      dateRdv:"",
      consultation_id: this.$route.params.kinesitherapie,
      maxFileSize:'',
      tinyKey: AppConfig.tinyMceKey,
      plugins: [
        'advlist autolink lists  image charmap',
        'searchreplace visualblocks code fullscreen',
        'print preview anchor insertdatetime media',
        'paste code help wordcount table'
      ],
      toolbar: 'undo redo | formatselect | bold italic | \
                           alignleft aligncenter alignright | \
                           bullist numlist outdent indent | help',
      afficherAntecedent: false,
      ligne_de_temps_id: [],
      file_id: this.$route.params.file,

       rdv:{
        praticien_id:'',

        isConsultantDoctor: '',

        medecinSource: '',

        doctorName: '',
      },
      paginationOptions: {
        enabled: true,
        mode: 'records',
        perPageDropdown: [3, 6, 10]
      },

      enabled: {enabled: true},

      sort: {
        enabled: true,
        initialSortBy: {field: 'date', type: 'desc'}
      },

      show: true,

    }
  },

  watch: {
  },


  methods:{
    deletedFile(fichier){
      let args = {
        file: fichier.slug,
      };

      let successMessage = this.$i18n.t('message.fileDeleted');

      let errorMessages = {
        generic: this.$i18n.t('message.genericError'),
        error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
      };

      this.$store.dispatch('deleteUploadFile', { args, errorMessages,successMessage });
    },

    openFile(fichier){
      window.open(AppConfig.imgUrl + '/public/storage/' + fichier.chemin);
    },
    filterResult(sArray, mArray) {
      if (this.filteredValue == 1) {
          mArray = sArray;
      } else if (this.filteredValue == 2) {
          //Non archivés
          mArray = _.filter(mArray, function (medecine) {
              return _.isNull(medecine.archievedAt);
          })
      } else if (this.filteredValue == 3) {
          //Non transmis
          mArray = _.filter(mArray, function (medecine) {
              return _.isNull(medecine.passedAt);
          })
      } else if (this.filteredValue == 4) {
          //Archivés
          mArray = _.filter(mArray, function (medecine) {
              return !_.isNull(medecine.archievedAt);
          })
      } else if (this.filteredValue == 5) {
          //Transmis
          mArray = _.filter(mArray, function (medecine) {
              return !_.isNull(medecine.passedAt);
          })
      }
      return mArray;
    },

    getConsultation() {
      let args = {
        consultation: this.consultation_id
      };

      this.$store.dispatch("getKinesitherapieConsultation", { args });

    },

    getDoctors() {
      let args = {
        offset: this.offset,
        limit: this.limit
      };

      this.$store.dispatch('getControlDoctors', { args : args });
    },

    getPractitioners() {
      let args = {
        offset: this.offset,
        limit: this.limit
      };

      this.$store.dispatch('getPractitioners', { args : args });
    },

    cleardocuments() {
      this.$refs['file_input'].reset()
    },

    getUserInstitutions() {
      let args = {
        offset: this.offset,
        limit: this.limit
      };

      this.$store.dispatch('getUserInstitutions', {args: args});
    },

    pathTo(element) {
      if (this.$route.fullPath.includes('#')) {
        let position = this.$route.fullPath.search('#');
        return this.$route.fullPath.substr(0, position) + element;
      }
      return this.$route.fullPath + element;
    },


    getInstitutions() {
      let args = {
        offset: this.offset,
        limit: this.limit
      };
      
      this.$store.dispatch('getInstitutions', {args: args});
    },

    notEmpty(item) {
      return item.length > 0;
    },

    getReasons() {
      let args = {
        offset: this.offset,
        limit: this.limit
      };

      this.$store.dispatch('getReasons', {args: args});
    },
    getTimelines() {
      let args = {
          file: this.file_id,
      };
      
      this.$store.dispatch("getTimelines", {
          args
      });
    },

    onSubmit: function (evt) {
      evt.preventDefault();

      this.$v.form.$touch();

      let files = this.$refs.file_input.selectedFile;
      let nomFichier = "";
        let praticien_id = '';
        if (this.form.isConsultantDoctor === 'true') {
          if (this.hasPraticienRole || this.hasMedecinControleRole || this.hasAssistante){
            praticien_id = JSON.parse(localStorage.getItem('user'))['id'];
          }

        } else if (this.form.medecinSource === 'fromMedicasure') {
          praticien_id = this.form.practicien_id;
        } else {
          praticien_id = this.form.doctorName;
        }
      if (!_.isNull(files)){
        _.forEach(files, function (file,key) {
          let taille = (((file.size)/1024)/1024).toFixed(4);
          if (taille > 5){
            nomFichier += key==0 ?'' :','+ file.name + ": "+taille + " Mo";
          }
        });

        if (nomFichier.length>0){
          this.maxFileSize = this.$i18n.t('message.maxFileSize') + nomFichier;
        }else{
          this.maxFileSize = "";
        }
      }
      if (!this.$v.form.$invalid && this.maxFileSize.length ==0) {
        let formData = new FormData();
        if (!_.isNull(this.dateRdv) && this.dateRdv!= 'Invalid date'){
          this.dateRdv = moment(this.dateRdv).format('YYYY-MM-DD HH:mm');
        }else{
          this.dateRdv = null;
        }
        formData.append('dossier_medical_id', this.KinesitherapieConsultation.dossier.id);
        formData.append('ligne_de_temps_id', this.form.ligne_de_temps_id);
        formData.append('contributeurs', this.form.contributors);
        formData.append('date_consultation', this.form.date_consultation);
        formData.append('anamnese', this.form.anamnese);
        formData.append('evaluation_globale', this.form.evaluation_globale);
        formData.append('impression_diagnostique', this.form.impression_diagnostique);
        formData.append('examens_complementaires', this.form.examens_complementaires);
        formData.append('conduite_a_tenir', this.form.conduite);
        formData.append('profession', this.form.profession);
        formData.append('etablissement_id', this.form.etablissement_id);
        formData.append('dateRdv', this.dateRdv);
        formData.append('motifRdv', this.form.rdv.motifs);
        formData.append('praticien_id', ''+praticien_id);
        // let self= this;
        if (!_.isNull(files)) {
          for (var i = 0; i < this.$refs.file_input.selectedFile.length; i++) {
            let file = this.$refs.file_input.selectedFile[i];
            formData.append('documents[' + i + ']', file);
          }
        }

        let successMessage = this.$i18n.t('message.kinesitherapyConsultationsUpdated');
        let errorMessages = {
          generic: this.$i18n.t('message.genericError'),
          error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
        };

        this.$store.dispatch('updateKinesitherapieConsultation', {args: formData,consultation: this.consultation_id, errorMessages, successMessage})
      } else {
        $('html, body').animate({scrollTop: 0}, '300');
      }
    },


    getErrorsField(field) {
      if (this.errorshasField(field)) {
        return this.errors[field][0];
      } else {
        return '';
      }
    },

    errorshasField(field) {
      return this.errors ? this.errors.hasOwnProperty(field) : false;
    },

    clearErrorField(field) {
      this.$store.dispatch('clearErrorField', {field});

      this.getErrorsField(field);

    }
  },

  validations: {
    rdv:{
      praticien_id:{
      },

      isConsultantDoctor: {

      },

      medecinSource: {

      },

      doctorName: {

      },
    },
    form: {
      rdv:{
        date:{},
        motifs:{},
              praticien_id:{
      },

      isConsultantDoctor: {

      },

      medecinSource: {

      },

      doctorName: {

      },
      },

      contributors:{

      },
      date_consultation: {
        required
      },

      anamnese: {
        //
      },

      examen_clinique: {
        //
      },

      conduite_a_tenir: {
        //
      },

      conclusion: {
        //
      },
      profession: {

      },
        conduite: {},
        evaluation_globale: {},
        examens_complementaires: {},
        impression_diagnostique: {},
      autres: {},

      etablissement_id: {
        required
      },
      ligne_de_temps_id: {
        required
      },
      traitements: {},

      rendez_vous: {},

      documents: {
        // required
      }
    },

  },

  mounted() {
    this.getConsultation(); 

    this.getTimelines();
    // Fetch control doctor list
    this.getDoctors();

    // Fetch practitioner list
    this.getPractitioners();

    // Fetch user institution list
    this.getUserInstitutions();

    // Fetch institution list
    this.getInstitutions();

    // Fetch reason list
    this.getReasons();

      new SlimSelect({
        select: '#timeLine',
        placeholder: 'Select or add timeLine',
        limit: 5
      });
    var singleMotif = new SlimSelect({
      select: '#singleMotif',
      placeholder: 'Select or add reason',
      addable: function (value) {
        if (singleMotif.selected().length == 5) {
          return false;
        } else {

          // Return the value string
          return value // Optional - value alteration // ex: value.toLowerCase()

        }
      },
      limit: 5

    });

    var btn = $('#button');

    $(window).scroll(function () {
      if ($(window).scrollTop() > 300) {
        btn.addClass('show');
      } else {
        btn.removeClass('show');
      }
    });

    btn.on('click', function (e) {
      e.preventDefault();
      $('html, body').animate({scrollTop: 0}, '300');
    });

  }

}
</script>

<style scoped>
</style>